import React from 'react';
import { Input, Button, message, Switch, DatePicker, Upload } from 'antd';
import { CloseCircleOutlined, InboxOutlined } from '@ant-design/icons';

import axios from '../../../Lib/axios';

import Title from '../../../Components/Common/pageTitle';
import { TableWrapper, TableContainer, Label, ValueBox } from './add.styled';

export default class AddProduct extends React.PureComponent {
    state = {
        isPublic: true,
        title: '',
        photo: '',
        startDate: '',
        endDate: '',
    };

    componentWillUnmount() {
        if (this.state.photo && typeof this.state.photo !== 'string') {
            URL.revokeObjectURL(this.state.photo);
        }
    }

    onAdd = async () => {
        const { isPublic, title, photo, startDate, endDate } = this.state;
        if (!photo) return message.warning('이미지를 선택하세요');
        if (!startDate) return message.warning('공개일을 선택해주세요');

        const formData = new FormData();
        formData.append('photo', photo);
        const header = { headers: { 'Content-Type': 'multipart/form-data' } };
        const { data: image } = await axios.post('/v1/popup/image/upload', formData, header);

        const { data } = await axios.post('/v1/popup/add', {
            isPublic,
            title,
            photo: image,
            startDate,
            endDate,
        });

        if (!data) return message.error('죄송합니다. 일시적인 서버 장애가 발생하였습니다.');
        if (data === 'check parameters') return message.warning('필수 정보들을 입력해주세요.');
        if (data === 'success') {
            message.success('팝업 등록완료');
            setTimeout(() => {
                this.props.history.goBack();
            }, 600);
        }
    };

    handleChange = e => {
        this.setState({ [e.target.name]: e.target.value });
    };

    handleSwitchChange = checked => {
        this.setState({ isPublic: checked });
    };

    handleStartDateChange = dateString => {
        this.setState({ startDate: dateString });
    };

    handleEndDateChange = dateString => {
        this.setState({ endDate: dateString });
    };

    handleFileChange = info => {
        if (info.file.status !== 'uploading') {
            const file = info.file.originFileObj || info.file;
            this.setState({ photo: file });
        }
    };

    handleRemoveImage = () => {
        this.setState({ photo: null });
    };

    render() {
        return (
            <>
                <Title title='팝업 등록' />
                <TableWrapper>
                    <TableContainer>
                        <>
                            <ValueBox>
                                <Label style={{ fontSize: '14px' }}>
                                    <b>공개 여부</b>
                                </Label>
                                <Switch checked={this.state.isPublic} onChange={this.handleSwitchChange} />
                            </ValueBox>

                            <ValueBox>
                                <Label style={{ fontSize: '14px' }}>
                                    <b>팝업 공개일</b>
                                </Label>
                                <DatePicker onChange={this.handleStartDateChange} />
                            </ValueBox>

                            <ValueBox>
                                <Label style={{ fontSize: '14px' }}>
                                    <b>팝업 마감일</b>
                                </Label>
                                <DatePicker onChange={this.handleEndDateChange} />
                            </ValueBox>

                            <ValueBox>
                                <Label style={{ fontSize: '14px' }}>
                                    <b>팝업명</b>
                                </Label>
                                <Input placeholder='팝업명을 입력해주세요.' value={this.state.title} name='title' onChange={this.handleChange} />
                            </ValueBox>

                            <ValueBox>
                                <Label style={{ fontSize: '14px' }}>
                                    <b>팝업 이미지</b>
                                </Label>

                                <Upload.Dragger
                                    name='photo'
                                    accept='image/*'
                                    beforeUpload={() => false}
                                    onChange={this.handleFileChange}
                                    showUploadList={false}
                                >
                                    {this.state.photo ? (
                                        <div style={{ position: 'relative', display: 'inline-block' }}>
                                            <img
                                                style={{
                                                    width: '300px',
                                                    height: '300px',
                                                    objectFit: 'contain',
                                                    borderRadius: '8px',
                                                }}
                                                src={typeof this.state.photo === 'string' ? this.state.photo : URL.createObjectURL(this.state.photo)}
                                                alt='사진 미리보기'
                                            />
                                            <CloseCircleOutlined
                                                onClick={e => {
                                                    e.stopPropagation();
                                                    this.handleRemoveImage();
                                                }}
                                                style={{
                                                    position: 'absolute',
                                                    top: '10px',
                                                    right: '10px',
                                                    fontSize: '20px',
                                                    color: 'red',
                                                    cursor: 'pointer',
                                                    backgroundColor: 'white',
                                                    borderRadius: '50%',
                                                }}
                                            />
                                        </div>
                                    ) : (
                                        <>
                                            <p className='ant-upload-drag-icon'>
                                                <InboxOutlined />
                                            </p>
                                            <p className='ant-upload-text'>이미지를 여기로 드래그하거나 클릭하여 업로드하세요.</p>
                                        </>
                                    )}
                                </Upload.Dragger>
                            </ValueBox>

                            <ValueBox style={{ textAlign: 'right' }}>
                                <Button type='primary' onClick={this.onAdd}>
                                    등록하기
                                </Button>
                            </ValueBox>
                        </>
                    </TableContainer>
                </TableWrapper>
            </>
        );
    }
}
